// src/utils/toReactNodes/stringToNodes.tsx
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
function stringToNodes(str) {
  return str.split("\n").map((str2, i, strArr) => {
    const key = `str-${i}-${str2.substr(0, 20)}`;
    return !str2 && i === strArr.length - 1 ? null : /* @__PURE__ */ jsxs("span", { children: [
      str2.length ? str2 : null,
      i < strArr.length - 1 ? /* @__PURE__ */ jsx("br", {}) : null
    ] }, key);
  });
}

export {
  stringToNodes
};
